import { API as AwsAPI, Auth as AwsAuth } from "aws-amplify";
import { MockApi, MockAuth } from "mock/mockApi";

// eslint-disable-next-line no-undef
const useMock = process.env.REACT_APP_USE_MOCK === "true";

export const API = useMock ? MockApi : AwsAPI;

export const Auth = useMock ? MockAuth : AwsAuth;
